module.exports = __webpack_public_path__ + "img/Picture2.c0c8df9e.jpg";